import { Link } from 'react-router'
import { useTranslation } from 'react-i18next'

export interface ResultCardWithHistoryLinkProps {
  children: React.ReactNode
  to: string
  linkState?: Record<string, unknown>
}

export function ResultCardWithHistoryLink({
  children,
  to,
  linkState,
}: ResultCardWithHistoryLinkProps) {
  const { t } = useTranslation()

  return (
    <div className="w-full">
      {children}
      <div className="flex items-center gap-3 mt-3 mb-4 px-4">
        <div className="flex-1 h-px bg-[var(--lotto-card-border)]" />
        <Link
          to={to}
          state={linkState}
          className="text-[var(--color-primary-400)] underline font-medium text-sm hover:opacity-80 whitespace-nowrap"
        >
          {t('resultPage.viewResultHistory')}
        </Link>
        <div className="flex-1 h-px bg-[var(--lotto-card-border)]" />
      </div>
    </div>
  )
}
